export const RequestSummarySet = ({ label, text }) => {
    return (
        <div className="block flex-row gap-2 mb-4">
            <div className="w-36 text-[#585757]">{label}</div>
            <div className="font-semibold text-[#333333] ">{text}</div>
        </div>
    );
};
